import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotPasswordService } from './forgot-password.service';
import { ForgotPassword } from './forgot-password';
import { AuthService } from '../services/auth.service';
import { Title } from '@angular/platform-browser';
import { Config } from '../../config/config';
import {Subscription} from 'rxjs';

var Base64 = require('js-base64').Base64;

@Component({
    selector: 'vnpt-login',
    templateUrl: './forgot-password.component.html',
    providers: [ForgotPasswordService]
    
})
export class ForgotPasswordComponent implements OnInit {
    
    emailCheck:string ="";
    item:ForgotPassword;
    status:string="";
    loading:boolean=false;
    success:boolean=false;
    fail:boolean = true;

    constructor(private service: ForgotPasswordService,
        public authService: AuthService,
        private router: Router,
        private titleService: Title) {
        titleService.setTitle("Đăng nhập hệ thống");
    }

    ngOnInit() {
        this.authService.showHeader = false;
        this.authService.showFooter = false;
        this.emailCheck = "";
        this.item = new ForgotPassword();
    }

    login() {
        this.loading = true;
        this.status= "Đang xử lý dữ liệu, vui lòng chờ trong giây lát";
        this.service.forgotPassword(this.item).subscribe(
                (resp) => {
                    if (resp.Success) {
                        this.status= resp.Message;
                        this.loading = false;
                        this.success = true;
                        this.fail = true;
                    }
                    else {
                        this.status= resp.Message;
                        this.loading = false;
                        this.success = false;
                         this.fail = false;
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                }
            )
       
    }
 
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/forgot-password/forgot-password.component.ts